document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tab-link').forEach(tabLink => {
        checkTabLink(tabLink);

        tabLink.addEventListener("click", (event) => handleClick(event, tabLink));
    });
});


function checkTabLink(tabLink) {
    const href = tabLink.getAttribute('href');
    if (href && href.startsWith('#')) {
        const targetElement = document.querySelector(href);
        if (!targetElement) {
            tabLink.parentElement.remove();
        }
    } else {
        tabLink.parentElement.remove();
    }
}

function handleClick(event, tabLink) {
    event.preventDefault();

    const href = tabLink.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const targetElement = document.querySelector(href);
    if (!targetElement) return;

    const offset = 175;
    const topPos = targetElement.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
        top: topPos,
        behavior: 'smooth'
    });
}